import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appSameAs]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: SameAsDirective,
      multi: true
    }
  ]
})
export class SameAsDirective implements Validator {
  @Input('appSameAs') compareTo!: AbstractControl;

  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value || !this.compareTo) {
      return null; // No validation if either value is missing
    }

    return control.value === this.compareTo.value ? null : { sameAs: true };
  }
}
